import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  onGetStarted: () => void;
  onScheduleDemo: () => void;
}

export default function CTASection({ onGetStarted, onScheduleDemo }: CTASectionProps) {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary via-secondary to-ocean relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          {/* Main Heading */}
          <h2 className="font-heading text-3xl lg:text-5xl font-bold mb-6">
            Ready to Transform Your Travel Business?
          </h2>
          
          <p className="text-xl lg:text-2xl text-white/90 mb-12 max-w-3xl mx-auto">
            Join 150+ airlines and 5,000+ developers building the future of travel technology with Dialforflight.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
            <button
              onClick={onGetStarted}
              className="inline-flex items-center space-x-2 bg-coral hover:bg-[#FF5722] text-white px-10 py-5 rounded-lg font-heading font-semibold text-lg shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
            >
              <span>Start Free Integration</span>
              <Icon name="ArrowRightIcon" size={24} />
            </button>

            <button
              onClick={onScheduleDemo}
              className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-10 py-5 rounded-lg font-heading font-semibold text-lg border-2 border-white/30 transition-all duration-300"
            >
              <Icon name="CalendarIcon" size={24} />
              <span>Schedule Demo Call</span>
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="grid md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-heading font-bold text-accent mb-2">150+</div>
              <div className="text-sm text-white/80">Airline Partners</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-heading font-bold text-accent mb-2">5,000+</div>
              <div className="text-sm text-white/80">Active Developers</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-heading font-bold text-accent mb-2">99.9%</div>
              <div className="text-sm text-white/80">API Uptime</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-heading font-bold text-accent mb-2">24/7</div>
              <div className="text-sm text-white/80">Support Available</div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-12 pt-12 border-t border-white/20">
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 text-sm text-white/80">
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircleIcon" size={20} className="text-accent" />
                <span>No credit card required</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircleIcon" size={20} className="text-accent" />
                <span>Free sandbox access</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircleIcon" size={20} className="text-accent" />
                <span>Cancel anytime</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}